import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface UpdateStoreState {
  isUpdating: boolean;
  setIsUpdating: (isUpdating: boolean) => void;
}

export const useUpdateStore = create<UpdateStoreState>()(
  devtools((set) => ({
    isUpdating: false,
    setIsUpdating: (isUpdating: boolean) => set({ isUpdating }),
  })),
);
